import { render } from "./EntitySelectorOrgaoAet.vue?vue&type=template&id=1cbbd425"
import script from "./EntitySelectorOrgaoAet.vue?vue&type=script&lang=ts"
export * from "./EntitySelectorOrgaoAet.vue?vue&type=script&lang=ts"
script.render = render

export default script